
import { validatePrice } from '../../utils/vaildtions'
import { getRandomString } from '../../utils/utils'
import wxp from '../../utils/wxp'
import { OSS_URL } from '../../config'
import {
  getWxMinaStoreInfoServer,
  createWxMinaOrderServer,
  getWxMinaOrderInfoServer,
  closeWxMinaOrderServer
} from '../../api/payment'
// 支付类型
const PAY_TYPE = {
  wechat: 'wxpay',
  alipay: 'alipay',
  unionpay: 'unionpay'
}
// 优化金额类型枚举
const DISCOUNT_TYPE = ['CHANNEL_DISCOUNT', 'CHANNEL_PRE']
Component({
  options: {
    pureDataPattern: /^_/ // 指定所有 _ 开头的数据字段为纯数据字段
  },
  properties: {
    // 供应商序列号
    vendorSn: {
      type: String,
      value: ''
    },
    // 供应商密钥
    secret: {
      type: String,
      value: ''
    },
    // 应用appid
    appId: {
      type: String,
      value: ''
    },
    // 用户唯一标识
    openId: {
      type: String,
      value: ''
    },
    // 码牌二维码地址
    qrCodeUrl: {
      type: String,
      value: ''
    },
    // 订单优惠标记，代金券或立减优惠功能的参数
    goodsTag: {
      type: String,
      value: ''
    },
    // 主题颜色
    themeColor: {
      type: String,
      value: '#32A0FA'
    },
    extentInfo: { // 扩展信息字段
      type: Object,
      value: {}
    }
  },
  data: {
    OSS_URL,
    isShowPage: false, // 是否显示页面
    isErrPage: false, // 是否显示的错误页面
    isSubmitIng: false, // 是否在提交中
    systemInfo: {
      model: '',
      isIphoneX: false
    },
    storeInfo: {
      store_name: '门店加载中...'
    },
    payInfo: {},
    inputMoney: '', // 输入金额
    keyboardInfo: { // 键盘组件
      show: true,
      disabled: true // true 置灰 false 可点击
    },
    isPaySucPage: false, // 是否显示支付成功的页面
    paySucInfo: {},// 支付成功信息
    fbLoadData: {
      message: '支付中',
      show: false
    }
  },
  observers: {
    // 监听必传参数，当为显示组件时初始化加载组件数据
    'appId, qrCodeUrl, vendorSn, secret': function (val1, val2, val3, val4) {
      if (val1 && val2 && val3 && val4) {
        this.init()
      } else {
        wxp.showLoading('加载中...')
      }
    }
  },
  methods: {
    /**
     * @function 初始化组件
     */
    init () {
      wxp.showLoading('加载中...')
      // 缓存供应商序列号和密钥
      wxp.setStorage('fb_vendorSn', this.data.vendorSn)
      wxp.setStorage('fb_secret', this.data.secret)
       // 加载系统信息，门店信息
      this.getSystemInfo()
      this.getStoreInfo({
        qrCodeUrl: this.data.qrCodeUrl
      })
    },
    /**
     * @function 获取系统信息
     */
    getSystemInfo () {
      if (!wx) return
      try {
        // 获取用户手机的基本信息
        let res:any = wx.getSystemInfoSync()
        // 是否是iphone X、iphone XR、iphone XS等苹果的全面屏手机
        if (res.model.indexOf('iPhone 13') > -1 || res.model.indexOf('iPhone13') > -1 || res.model.indexOf('iPhone 12') > -1 || res.model.indexOf('iPhone X') > -1 || res.model.indexOf('iPhone12') > -1 || res.model.indexOf('iPhone11') > -1) {
          res.isIphoneX = true
        } else {
          // android 全面屏statusBarHeight一般都大于25 android全面屏兼容
          if (res.statusBarHeight - 25 > 0) {
            res.isFullScreen = true
          } else {
            res.isIphoneX = false
          }
        }
        this.setData({
          systemInfo: res
        })
      } catch (e) {}
    },
    /**
     * @function 获取门店信息
     */
    getStoreInfo (params) {
      getWxMinaStoreInfoServer(params).then(res => {
        const { bind } = res
        this.setData({
          storeInfo: res
        })
        this.setData({
          isShowPage: true,
          isErrPage: !bind
        })
      })
      .catch(() => {
        this.setData({ isErrPage: true })
      }).finally(() => {
        wxp.hideLoading()
      })
    },
    /**
     * @function 错误页面点击
     */
    handleErrPage (e) {
      this.triggerEvent('errClick', e)
    },
    /**
     * @function 付呗loading
     * */
    showFbLoading (loading = true, message = '支付中') {
      this.setData({
        'fbLoadData.show': loading,
        'fbLoadData.message': message
      })
    },
    /**
     * @function 显示键盘
     */
    showKeyboard () {
      this.setData({
        'keyboardInfo.show': true
      })
    },
    /**
     * @function 清空金额输入数据
     */
    clearMoney () {
      if (this.data.inputMoney === '') {
        return false
      }
      this.setData({
        inputMoney: '',
        'keyboardInfo.disabled': true
      })
    },
    /**
     * @function 点击键盘
     * @param {Object} e 键值
     **/
    clickKeyBoard (e) {
      const key = e.detail
      switch (key) {
        case 'down':
          this.setData({
            'keyboardInfo.show': false
          })
          break
        case 'x':
          this.moneyChange('', true)
          break
        case 'ok':
          if (validatePrice(this.data.inputMoney)) {
            this.confirmPay()
          } else {
            wxp.showToast('请输入支付金额')
          }
          break
        default:
          this.moneyChange(key)
          break
      }
    },
      /**
     * @function 输入金额正确后,各项金额的变化
     * @param {String} val 输入的值
     * @param {Boolean} reduce 是不是减去
     * */
    moneyChange (val, reduce) {
      const preValue = '' + this.data.inputMoney
      if (!reduce) {
        // 输入金额
        let afterValue = preValue + val
        if (afterValue === '.') {
          afterValue = '0.'
        }
        if (afterValue.indexOf('.') < 0 && +afterValue > 100000) {
          wxp.showToast('单次输入金额不超过100000元')
        }
        if (validatePrice(afterValue)) {
          this.setData({
            inputMoney: afterValue,
            'keyboardInfo.disabled': !+afterValue
          })
        }
      } else {
        // 输入金额（删减金额）
        const afterValue = preValue.substring(0, preValue.length - 1)
        if (!+afterValue) {
          // 删除为空时
          this.setData({
            'keyboardInfo.disabled': true
          })
        }
        this.setData({
          inputMoney: afterValue
        })
      }
    },
    /**
     * @function 重置loading和防重复
     * */
    resetLoadingAndFlag () {
      this.setData({
        isSubmitIng: false
      })
    },
    /**
     * @function 确认支付
     */
    confirmPay () {
      if (!this.data.inputMoney) {
        wxp.showToast('请输入支付金额')
        return
      }
      if (!this.data.openId) {
        wxp.showToast('网络连接异常，请重新扫码')
        return
      }
      this.createWxOrder()
    },
    /**
     * @function 创建微信订单
     */
    createWxOrder () {
      wxp.showLoading('支付中...')
      if (!this.data.isSubmitIng) {
        this.setData({ isSubmitIng: true})
        const { store_id, merchant_id, device_no } = this.data.storeInfo
        const { inputMoney, openId, appId, goodsTag, extentInfo } = this.data
        const merchant_order_sn = getRandomString()
        const params = {
          store_id,
          merchant_id,
          merchant_order_sn,
          device_no,
          pay_type: PAY_TYPE.wechat,
          user_id: openId,
          sub_appid: appId,
          goods_tag: goodsTag,
          total_amount: inputMoney,
          ...extentInfo
        }
        createWxMinaOrderServer(params).then(res => {
          wxp.hideLoading()
          setTimeout(() => {
            this.wxPay(res)
          }, 50)
        })
        .catch((err) => {
          wxp.hideLoading()
          this.resetLoadingAndFlag()
          if (err.result_message) {
            wxp.showToast(err.result_message)
          }
        })
      }
    },
    /**
     * @function 微信支付接口
     * @param {*} params
     * @return {*}
     */  
    wxPay (params) {
      const { order_sn, sign_package } = params
      wxp.requestPayment({
        appId: sign_package.appId,
        timeStamp: sign_package.timeStamp,
        nonceStr: sign_package.nonceStr,
        package: sign_package.package,
        signType: sign_package.signType,
        paySign: sign_package.paySign
      })
      .then(res => {
        this.getOrderDetail(order_sn)
      })
      .catch(err => {
        if (err.errMsg === 'requestPayment:fail cancel') { // 取消支付
          this.triggerEvent('cancelPay', err)
          this.cancelWxPay(order_sn)
        }
      }).finally(() => {
        this.resetLoadingAndFlag()
      })
    },
    /**
     * @function 微信取消支付
     */
    cancelWxPay (order_sn) {
      const { merchant_id } = this.data.storeInfo
      closeWxMinaOrderServer({
        order_sn,
        merchant_id
      }).then(() => {
        // console.log('取消支付-res: ', res)
      })
    },
    /**
     * @function 获取订单详情
     */
    getOrderDetail (order_sn) {
      wxp.showLoading('加载中...')
      const { merchant_id } = this.data.storeInfo
      getWxMinaOrderInfoServer({
        order_sn,
        merchant_id
      }).then(res => {
        wxp.hideLoading()
        const { payment_list } = res
        if (payment_list && payment_list.length) { // 计算优惠金额
          res.discountAmount = 0
          payment_list.forEach(item => {
            if (DISCOUNT_TYPE.includes(item.type)) {
              res.discountAmount += item.amount
            }
          })
        }
        this.setData({
          paySucInfo: res
        })
        this.setData({
          isPaySucPage: true
        })
      })
      .catch((err) => {
        wxp.hideLoading()
        if (err.result_message) {
          wxp.showToast(err.result_message)
        }
      })
    }
  }
})
